import React, { useRef } from "react";
import PropTypes from "prop-types";
import { COLOR_OPTIONS } from "./staffingFormatters";

const STEP_KEYS = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };

const ColorSwatches = ({ id, label, value, onChange }) => {
  const buttons = useRef([]);
  const known = COLOR_OPTIONS.some((option) => option.value.toLowerCase() === value.toLowerCase());
  const options = known ? COLOR_OPTIONS : [...COLOR_OPTIONS, { value, label: "Current color" }];
  const selectedIndex = options.findIndex((option) => option.value.toLowerCase() === value.toLowerCase());

  const select = (index) => {
    onChange(options[index].value);
    buttons.current[index]?.focus();
  };

  const onKeyDown = (event) => {
    const last = options.length - 1;
    let index;
    if (event.key in STEP_KEYS) index = (selectedIndex + STEP_KEYS[event.key] + options.length) % options.length;
    else if (event.key === "Home") index = 0;
    else if (event.key === "End") index = last;
    else return;
    event.preventDefault();
    select(index);
  };

  return (
    <div>
      <span id={`${id}-label`} className="d-block mb-2" style={{ fontSize: 14, lineHeight: "20px", color: "var(--sl-text-secondary)" }}>
        {label}
      </span>
      <div role="radiogroup" aria-labelledby={`${id}-label`} className="d-flex flex-wrap" style={{ gap: 10 }} onKeyDown={onKeyDown}>
        {options.map((option, index) => {
          const selected = index === selectedIndex;
          const ring = option.value || "var(--sl-fg-quaternary)";
          return (
            <button
              key={option.label}
              ref={(button) => (buttons.current[index] = button)}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={option.label}
              title={option.label}
              tabIndex={selected ? 0 : -1}
              onClick={() => select(index)}
              style={{
                width: 28,
                height: 28,
                padding: 0,
                borderRadius: "50%",
                cursor: "pointer",
                border: option.value ? "none" : "1px solid var(--sl-border-primary)",
                background:
                  option.value ||
                  "linear-gradient(135deg, transparent 46%, var(--sl-fg-quaternary) 46%, var(--sl-fg-quaternary) 54%, transparent 54%), var(--sl-bg-primary)",
                boxShadow: selected ? `0 0 0 2px var(--sl-bg-primary), 0 0 0 4px ${ring}` : "none",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

ColorSwatches.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ColorSwatches;
